"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.strPadLeft = exports.formatMinutesAndSeconds = exports.format = exports.Formats = void 0;

/**
 *  Copyright AlpineReplay Inc, 2021. All rights reserved.
 *  Authors: Brian Bal
 */
var tracerRegex = /Tracer(\s+?-?\d+?)?/gi;
/**
 * Enum for format types
 * @readonly
 * @enum {number}
 */

var Formats = {
  /** Player to full name string ex: John Smith */
  PlayerFullName: 1,

  /** Player to last name string ex: Smith */
  PlayerLastName: 2,

  /** Player to first name string ex: John */
  PlayerFirstName: 3,

  /** Player to short name string ex: J. Smith */
  PlayerShortName: 4,

  /** Player to initials name string ex: JS */
  PlayerAbbr: 5,

  /** Integer number to integer string ex: 12 */
  Integer: 6,

  /** Integer number to float string ex: 12.1 */
  Float: 7,

  /** Integer number to double string ex: 12.14 */
  Double: 8,

  /** Integer number to percentage string ex: 12% */
  Percentage: 9,

  /** Integer number to ordinal string ex: 12th */
  Ordinal: 10
};
/**
 * formats input to a specicifed format
 *
 * @param {*} from
 * @param {Formats} format
 * @return {string}
 */

exports.Formats = Formats;

var format = function format(from, _format) {
  if (!_format) {
    throw new Error("format must be specified");
  }

  switch (_format) {
    case Formats.PlayerFullName:
      return formatPlayerFullName(from);

    case Formats.PlayerShortName:
      return formatPlayerShortName(from);

    case Formats.PlayerLastName:
      return formatPlayerLastName(from);

    case Formats.PlayerFirstName:
      return formatPlayerFirstName(from);

    case Formats.PlayerAbbr:
      return formatPlayerAbbr(from);

    case Formats.Integer:
      return formatInteger(from);

    case Formats.Float:
      return formatFloat(from);

    case Formats.Double:
      return formatDouble(from);

    case Formats.Percentage:
      return formatPercentage(from);

    case Formats.Ordinal:
      return formatOrdinal(from);

    default:
      throw new Error("invalid format");
  }
};

exports.format = format;

var formatInteger = function formatInteger(val) {
  var cval = parseInt(val, 10);
  return "".concat(cval);
};

var formatPercentage = function formatPercentage(val) {
  var cval = Math.round(val);
  return "".concat(cval, "%");
};

var formatDouble = function formatDouble(val) {
  var cval = Math.floor(val * 100) / 100;
  return "".concat(cval);
};

var formatFloat = function formatFloat(val) {
  var cval = Math.floor(val * 10) / 10;
  return "".concat(cval);
};

var formatOrdinal = function formatOrdinal(val) {
  var cval = parseInt(val, 10);
  var mod10 = cval % 10;
  var suffix;

  switch (mod10) {
    case 1:
      if (cval === 11) {
        suffix = "th";
      } else {
        suffix = "st";
      }

      break;

    case 2:
      if (cval === 12) {
        suffix = "th";
      } else {
        suffix = "nd";
      }

      break;

    case 3:
      if (cval === 13) {
        suffix = "th";
      } else {
        suffix = "rd";
      }

      break;

    default:
      suffix = "th";
      break;
  }

  return "".concat(cval).concat(suffix);
};

var formatPlayerFullName = function formatPlayerFullName(player) {
  var name = "";
  var fname = "";
  var lname = "";

  if (player.first_name) {
    fname = player.first_name;
  } else if (player.user && player.user.first_name) {
    fname = player.user.first_name;
  }

  if (player.last_name) {
    lname = player.last_name;
  } else if (player.user && player.user.last_name) {
    lname = player.user.last_name;
  }

  if (fname.match(tracerRegex)) {
    fname = "Tracer";
    lname = "";

    if (player.trace_number) {
      fname = "Tracer ".concat(player.trace_number);
    } else if (player.id) {
      fname = "Tracer ".concat(player.id);
    } else if (player.default_trace_number) {
      fname = "Tracer ".concat(player.default_trace_number);
    }
  }

  name += fname;
  name += " ";
  name += lname;
  return name.trim();
};

var formatPlayerShortName = function formatPlayerShortName(player) {
  var name = "";
  var fname = "";
  var lname = "";

  if (player.first_name) {
    fname = player.first_name;
  } else if (player.user && player.user.first_name) {
    fname = player.user.first_name;
  }

  if (player.last_name) {
    lname = player.last_name;
  } else if (player.user && player.user.last_name) {
    lname = player.user.last_name;
  }

  tracerRegex.lastIndex = 0;

  if (fname.match(tracerRegex) || lname.match(tracerRegex)) {
    fname = "Tracer";
    lname = "";

    if (player.trace_number) {
      fname = "Tracer ".concat(player.trace_number);
    } else if (player.id) {
      fname = "Tracer ".concat(player.id);
    } else if (player.default_trace_number) {
      fname = "Tracer ".concat(player.default_trace_number);
    }

    return fname;
  }

  name += fname.length > 0 ? fname.substring(0, 1) + "." : "";
  name += " ";
  name += lname;
  return name.trim();
};

var formatPlayerLastName = function formatPlayerLastName(player) {
  var fname = "";
  var lname = "";

  if (player.first_name) {
    fname = player.first_name;
  } else if (player.user && player.user.first_name) {
    fname = player.user.first_name;
  }

  if (player.last_name) {
    lname = player.last_name;
  } else if (player.user && player.user.last_name) {
    lname = player.user.last_name;
  }

  if (fname.match(tracerRegex)) {
    fname = "Tracer";
    lname = "";

    if (player.trace_number) {
      fname = "Tracer ".concat(player.trace_number);
    } else if (player.id) {
      fname = "Tracer ".concat(player.id);
    } else if (player.default_trace_number) {
      fname = "Tracer ".concat(player.default_trace_number);
    }
  }

  return lname.trim();
};

var formatPlayerFirstName = function formatPlayerFirstName(player) {
  var fname = "";
  var lname = "";

  if (player.first_name) {
    fname = player.first_name;
  } else if (player.user && player.user.first_name) {
    fname = player.user.first_name;
  }

  if (player.last_name) {
    lname = player.last_name;
  } else if (player.user && player.user.last_name) {
    lname = player.user.last_name;
  }

  if (fname.match(tracerRegex)) {
    fname = "Tracer";
    lname = "";

    if (player.trace_number) {
      fname = "Tracer ".concat(player.trace_number);
    } else if (player.id) {
      fname = "Tracer ".concat(player.id);
    } else if (player.default_trace_number) {
      fname = "Tracer ".concat(player.default_trace_number);
    }
  }

  return fname.trim();
};

var formatPlayerAbbr = function formatPlayerAbbr(player) {
  var name = "";
  var fname = "";
  var lname = "";

  if (player.first_name) {
    fname = player.first_name;
  } else if (player.user && player.user.first_name) {
    fname = player.user.first_name;
  }

  if (player.last_name) {
    lname = player.last_name;
  } else if (player.user && player.user.last_name) {
    lname = player.user.last_name;
  }

  if (fname.match(tracerRegex)) {
    fname = "Tracer";
    lname = "";

    if (player.trace_number) {
      fname = "Tracer ".concat(player.trace_number);
    } else if (player.id) {
      fname = "Tracer ".concat(player.id);
    } else if (player.default_trace_number) {
      fname = "Tracer ".concat(player.default_trace_number);
    }
  }

  name += fname.length > 0 ? fname.substring(0, 1) : "";
  name += lname.length > 0 ? lname.substring(0, 1) : "";
  return name.trim();
};

var strPadLeft = function strPadLeft(string, pad, length) {
  return (new Array(length + 1).join(pad) + string).slice(-length);
};

exports.strPadLeft = strPadLeft;

var formatMinutesAndSeconds = function formatMinutesAndSeconds(time) {
  var minutes = Math.floor(time / 60);
  var seconds = Math.floor(time - minutes * 60);
  var result = strPadLeft(minutes, "0", 2) + ":" + strPadLeft(seconds, "0", 2);
  return result;
};

exports.formatMinutesAndSeconds = formatMinutesAndSeconds;